import { render, staticRenderFns } from "./GeneralResults.vue?vue&type=template&id=6c9863b2&scoped=true"
import script from "./GeneralResults.vue?vue&type=script&lang=js"
export * from "./GeneralResults.vue?vue&type=script&lang=js"
import style0 from "./GeneralResults.vue?vue&type=style&index=0&id=6c9863b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9863b2",
  null
  
)

export default component.exports